import gql from "graphql-tag";

export const deleteRoleMutation = gql`
  mutation deleteRole($id: ID!) {
    deleteRole(id: $id) {
      id
    }
  }
`;
